// External Dependencies
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';

// Internal Dependencies
import { isMobileScreenSize } from 'state/selectors';
import { useIsOpen } from 'hooks/useIsOpen';
import { DangerZone } from 'components/shared';

// Local Dependencies
import DeleteDistrictDialog from './DeleteDistrictDialog';

// Local Typings
interface Props {
  adminPortalId: GQL.IDistrict['id'];
  districtName: GQL.IDistrict['label'];
}

// Component Definition
const DistrictDangerZone = ({ adminPortalId, districtName }: Props): JSX.Element => {
  const isMobileScreen = useSelector(isMobileScreenSize);

  const {
    isOpen: isDeleteDialogOpen,
    toggleIsOpen: toggleIsDeleteDialogOpen,
  } = useIsOpen();

  const dangerZoneItems = [
    {
      buttonText: isMobileScreen ? 'Start' : 'Start Deletion',
      description: `Mark the ${districtName} admin portal as deleted.`,
      onClick: toggleIsDeleteDialogOpen,
      title: 'Delete this admin portal',
    },
  ];

  return (
    <Box marginTop={2}>
      <DangerZone
        items={dangerZoneItems}
      />

      <DeleteDistrictDialog
        adminPortalId={adminPortalId}
        isOpen={isDeleteDialogOpen}
        onClose={toggleIsDeleteDialogOpen}
      />
    </Box>
  );
};

export default DistrictDangerZone;
